import { applyOpacity } from "./utils";
import { css } from "styled-components";

/**
 * A subtle shadow used for elements that appear over the main app
 * (eg bottom sheet)
 */
const subtleShadow = css`
  box-shadow: 0px 0px 32px 0px
    ${({ theme }) => applyOpacity(theme.colours.dark, 0.1, false)};
`;

/**
 * Forms a solid 1px white inset "border", usually paired with an actual border
 * for focus styling.
 */
const whiteInsetBorderShadow = css`
  box-shadow: inset 0 0 0 1px ${({ theme }) => theme.colours.white};
`;

export const boxShadows = {
  subtleShadow,
  whiteInsetBorderShadow,
} as const;
